import { render, staticRenderFns } from "./totalSearch.vue?vue&type=template&id=276e3c4a&scoped=true&"
import script from "./totalSearch.vue?vue&type=script&lang=js&"
export * from "./totalSearch.vue?vue&type=script&lang=js&"
import style0 from "./totalSearch.vue?vue&type=style&index=0&id=276e3c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e3c4a",
  null
  
)

export default component.exports